import env from "shared/constants/env";

export const API_URL = env.API_ENDPOINT.replace('/v1/','');